import { Link as UntypedLink } from 'gatsby';
import type { GatsbyLinkProps } from 'gatsby-link';
import type { ForwardRefExoticComponent, RefAttributes } from 'react';

// gatsby-link ships a class-component type (`class Link<TState> extends
// React.Component<...>`), so TypeScript types `ref` as that class instance.
// At runtime the package actually exports `React.forwardRef(...)` wrapping a
// plain <a> — `ref` genuinely resolves to the anchor element. See
// node_modules/gatsby-link/dist/index.js, the `React.forwardRef(...)` export
// assigned to `exports.Link`.
export const Link = UntypedLink as unknown as ForwardRefExoticComponent<
  GatsbyLinkProps<unknown> & RefAttributes<HTMLAnchorElement>
>;
